<template>
  <div class="c-base-link">
    <span class="c-base-link__label" v-if="label">{{ label }}</span>
    <router-link :to="to" class="c-base-link__to">
      <font-awesome-icon v-if="type === 'back'" :icon="['fas', 'arrow-left']" class="c-base-link__icon-prepend mr-2"/>
      <span :class="['c-base-link__text', { 'font-semibold': type !== 'back' }]">{{ content }}</span>
      <font-awesome-icon v-if="type === 'forward'" :icon="['fas', 'arrow-right']" class="c-base-link__icon-append ml-2"/>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BaseLink',

  props: {
    label: {
      type: String,
      required: false
    },
    content: {
      type: String,
      required: true
    },
    to: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: false,
      validator: value => [ 'back', 'forward' ].includes(value)
    }
  }
}
</script>
